import { useState, useEffect } from "react";
import { onAuthStateChanged, User as FirebaseUser, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { FIREBASE_AUTH } from "@/lib/firebase";

export function useAuth() {
  const [user, setUser] = useState<FirebaseUser | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(FIREBASE_AUTH, (u) => {
      setUser(u ?? null);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const login = async (email: string, password: string) => {
    const cred = await signInWithEmailAndPassword(FIREBASE_AUTH, email, password);
    return cred.user;
  };

  const logout = async () => {
    await signOut(FIREBASE_AUTH);
  };

  return { user, loading, login, logout };
}
